import type { FeatureFinishedTuning } from "@slot/game-shell";
import type { PanelMotionTuning } from "../views/PanelMotion";

/**
 * Per-game FEATURE-FINISHED panel tuning VALUES — the ONLY file to edit to retune it. The shell's part
 * (`FeatureFinishedTuning`: the arm delay, the music) is passed whole into the shell's presenter (wired in
 * createPresentation); the view's motion is `anim` (`PanelMotionTuning`, the title's own since decision 40 #21).
 */
export const FEATURE_FINISHED_TUNING: FeatureFinishedTuning & { anim: PanelMotionTuning } = {
  armDelayMs: 800,
  music: {
    // The finished intro, then the idle bed (silenced by its gain, createGameAudioOverrides), then the base loop.
    idleId: "music_feature_idle",
    finishedIntroId: "music_feature_finished_intro",
    loopId: "music_feature_free_spins",
    // A buy from the offer returns to the feature's own loop (VS Rush → its own); the others to the default.
    loopIdByFeatureId: { vs_rush_buy: "music_feature_free_spins_2" },
    loopFadeMs: 1500,
    baseId: "music_base",
  },
  anim: {
    enterScaleFrom: 0.85,
    enterDurationSeconds: 0.35,
    exitScaleTo: 0.9,
    exitDurationSeconds: 0.25,
    continueFadeInSeconds: 0.4,
    continueFadeOutSeconds: 0.2,
    loopPanelScaleMax: 1.025,
    loopPanelHalfSeconds: 1.2,
    loopTitleScaleMax: 1.05,
    loopTitleHalfSeconds: 0.7,
  },
};
